import { render, staticRenderFns } from "./RequestHistoryItem.vue?vue&type=template&id=8a7698b4&scoped=true&"
import script from "./RequestHistoryItem.vue?vue&type=script&lang=js&"
export * from "./RequestHistoryItem.vue?vue&type=script&lang=js&"
import style0 from "./RequestHistoryItem.vue?vue&type=style&index=0&id=8a7698b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a7698b4",
  null
  
)

export default component.exports